module.exports = __webpack_public_path__ + "static/img/解决方案-矿山全场景AI视频识别解决方案-固定硐室无人值守.8d3c53a4.png";